var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('div',{attrs:{"id":"header"}}),_c('div',{staticClass:"conts"},[_c('div',{staticClass:"wapper"},[_c('div',{staticClass:"error_page"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.showDetailText)?_c('blockquote',{domProps:{"innerHTML":_vm._s(_vm.getDetailText)}}):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }